import { Dispatch, SetStateAction } from 'react'

import {
  CUSTOMER_SEARCH_CONDITION_CLEAR,
  CustomerFilterStatus,
  CustomerSearchCondition
} from '@/common/api/modules/customer'
import { isSameSearchCondition } from '@/common/api/search'

import Button from '@/components/view/atoms/button/Button'
import SortButton from '@/components/view/atoms/button/SortButton'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import FormRow from '@/components/view/layouts/form/FormRow'

interface Props {
  condition: CustomerSearchCondition
  setCondition: Dispatch<SetStateAction<CustomerSearchCondition>>
}

const AccessCustomerSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, CUSTOMER_SEARCH_CONDITION_CLEAR)

  return (
    <SearchConditionAreaContent>
      <FormRow gap={8} size={TextBoxSize.FULL} align='center'>
        <TextField
          type='search'
          size={TextBoxSize.FULL}
          value={condition.keyword ?? ''}
          onChange={(e) =>
            setCondition((c) => ({ ...c, page: 1, keyword: e.target.value || null }))
          }
          placeholder='クッキーID・顧客IDで検索する'
        />
      </FormRow>
      <SortButtonList>
        {Object.values(CustomerFilterStatus).map((status) => (
          <SortButton
            key={status}
            selected={(condition.status ?? '') === status}
            noPulldown
            onClick={() =>
              setCondition((c) => ({
                ...c,
                page: 1,
                status: (status as CustomerFilterStatus) || null
              }))
            }
          >
            {status == CustomerFilterStatus.ALL
              ? 'すべて'
              : status === CustomerFilterStatus.MEMBER
                ? '会員'
                : '不明ユーザー'}
          </SortButton>
        ))}
        <Button
          color='secondary'
          disabled={isDefault}
          onClick={() => setCondition(CUSTOMER_SEARCH_CONDITION_CLEAR)}
        >
          条件をリセット
        </Button>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default AccessCustomerSearchConditionField
